import { ViewStream } from 'spyne';
import { ContactUsTraits } from 'traits/contact-us-traits.js';

export class ContactUsView extends ViewStream {
  constructor(props = {}) {
    props.traits = [ContactUsTraits];
    props.channels = ["CHANNEL_UI"];
    props.mode = 'api';
    props.apiUrl = 'http://localhost:8223/mock/contact';


    super(props);
  }

  addActionListeners() {
    return [['CHANNEL_UI_SUBMIT_EVENT', 'contactUs$SendFormData']];
  }

  onContactUs(e){

    console.log("SUBMIT HAS BEEN CALLED ", )
  }

  broadcastEvents() {
    return [
      ['form', 'submit']
    ];
  }

  onRendered() {}
}
